import { ThunkDispatch } from 'redux-thunk';
import {
  clearUpdateEmployeeRoleStatus,
  updateEmployeeRole,
  updateEmployeeStatusDrops,
  updateEmployeePersonalDetails,
} from '../../../features/employeeDataSlice';
import {
  ApiResponseStatusType,
  EmployeeInformationFilterType,
  EmployeeListItemType,
  SelectOptionType,
} from '../../../utils/Types';
import { API_STATUS, CLICK_ACTIONS } from '../../../utils/Constant';
import { toast } from 'react-toastify';
import { isAPIFailed, isAPISuccess } from '../../../utils/Util';

export const getEmpDateReqParam = (
  currentPage: number,
  pageSize: number,
  selectedFilter?: EmployeeInformationFilterType
) => {
  const data: any = {
    pageNumber: currentPage,
    pagePerCount: pageSize,
  };
  if (selectedFilter?.employeeId) {
    data.employeeUniqueId = selectedFilter?.employeeId;
  }
  if (selectedFilter?.employeeName) {
    data.employeeName = selectedFilter?.employeeName;
  }
  if (selectedFilter?.mobileNumber) {
    data.mobileNumber = selectedFilter?.mobileNumber;
  }
  if (selectedFilter?.role?.value) {
    data.role = selectedFilter?.role.value;
  }
  if (selectedFilter?.city.value) {
    data.city = selectedFilter?.city.value;
  }
  if (selectedFilter?.zone.value) {
    data.zone = selectedFilter?.zone.value;
  }
  if (selectedFilter?.state.value) {
    data.state = selectedFilter?.state.value;
  }
  if (selectedFilter?.district.value) {
    data.district = selectedFilter?.district.value;
  }
  if (selectedFilter?.status.value) {
    data.status = selectedFilter?.status.value;
  }
  return data;
};
export const updateRole = (
  rolesArray: SelectOptionType[],
  selectedEmployee: EmployeeListItemType | null | undefined,
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  setSelectedEmployee: (value: EmployeeListItemType | null) => void,
  setIsRoleModal: (value: boolean) => void
) => {
  const roles: number[] = [];
  for (const element of rolesArray) {
    roles.push(Number(element.value));
  }
  if (selectedEmployee?.candidateId) {
    dispatch(clearUpdateEmployeeRoleStatus({}));
    const data = {
      candidateId: selectedEmployee?.candidateId,
      roles,
    };
    setShowLoader(true);
    dispatch(updateEmployeeRole(data));
    setSelectedEmployee(null);
    setIsRoleModal(false);
  }
};
export const onRoleUpdate = (
  roleUpdateStatus: ApiResponseStatusType,
  selectedFilter: EmployeeInformationFilterType | undefined,
  setShowLoader: (value: boolean) => void,
  findEmployeeList: (selectedFilter?: EmployeeInformationFilterType) => void
) => {
  if (roleUpdateStatus.status) {
    setShowLoader(false);
    if (roleUpdateStatus.status === API_STATUS.SUCCEEDED) {
      toast.success(roleUpdateStatus.response.responseMessage);
      findEmployeeList(selectedFilter);
    } else {
      toast.error(roleUpdateStatus.response.responseMessage);
    }
  }
};
export const updateStatus = (
  candidateId: number | undefined,
  selectedStatus: number | null,
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  toggleModal: (value: string) => void
) => {
  setShowLoader(true);
  dispatch(
    updateEmployeeStatusDrops({
      candidateId: candidateId,
      employeeStatus: selectedStatus,
    })
  )
    .then((fulfilled: any) => {
      setShowLoader(false);
      if (isAPISuccess(fulfilled.payload)) {
        toast.success(fulfilled.payload.responseInformation.responseMessage);
        toggleModal(CLICK_ACTIONS.REFRESH_LIST);
      } else if (isAPIFailed(fulfilled.payload)) {
        toast.error(fulfilled.payload.responseInformation.responseMessage);
      } else {
        toast.error(fulfilled.responseInformation.responseMessag);
      }
    })
    .catch(() => {
      setShowLoader(false);
      toast.error('Something went wrong');
    });
};
export { updateEmployeePersonalDetails };
